var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',{attrs:{"header":"Methods list"}},[_c('Header'),_vm._l((_vm.roles),function(role,entityName){return _c('Row',{key:entityName,attrs:{"role":role,"roles":_vm.group.roles,"entity-name":entityName},on:{"onRoleChanged":_vm.handleRoleChanged}})})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }